<template>
  <div
    id="a-wrapper"
    class="a-wrapper a-uno fixed inset-0 h-full w-full overflow-x-hidden overflow-y-auto bg-[#100908]"
  >
    <div class="a-stage relative min-h-full h-screen w-full overflow-hidden">
      <img
        class="a-bg absolute inset-0 h-full w-full pointer-events-none"
        src="@/assets/images/landing-a/pc-bg.webp"
        alt=""
      />
      <!-- <div
        class="absolute inset-0 bg-[linear-gradient(-50.503deg,rgba(12,4,4,0)_5.917%,rgba(10,4,4,0.85)_46.798%)]"
        aria-hidden="true"
      ></div> -->
      <!-- 露骨人物素材使用同尺寸纯色 WebP 占位。 -->
      <img
        class="a-character absolute right-[300px] bottom-0 w-[700px] h-auto pointer-events-none"
        src="@/assets/images/landing-a/pc-character-placeholder.webp"
        alt=""
      />
      <div
        class="absolute right-0 bottom-[20px] w-[552px] h-auto flex items-center justify-center pointer-events-none"
      >
        <img
          class="a-phone w-full h-auto"
          src="@/assets/images/landing-a/pc-phone-placeholder.webp"
          alt=""
        />
      </div>
      <img
        class="a-title absolute left-[30px] top-[80px] w-[900px] h-auto pointer-events-none"
        src="@/assets/images/landing-a/pc-title.webp"
        alt="夜深了，心动才刚刚开始。故事越往后，越舍不得说晚安。"
      />
      <div class="a-download absolute left-[178.233px] bottom-[20px] w-[614px]">
        <img
          class="block w-full h-auto pointer-events-none"
          src="@/assets/images/landing-a/pc-download-module.webp"
          alt="扫码下载，解锁今晚的心跳。继续看下去。安卓手机建议使用UC浏览器扫码。请断开网络安装，安装本APP不会对您的手机造成任何损害。"
        />
        <div
          class="a-qr-box absolute left-0 top-[77px] w-[192px] h-[232.482px]"
        >
          <img
            class="a-qr absolute left-[11.5px] top-[11.5px] w-[168.5px] h-[168.5px]"
            :src="qrImg"
            alt="下载二维码"
          />
        </div>
      </div>
      <div
        class="a-nav absolute inset-x-0 top-0 z-10 h-[90px] px-[80px] flex items-center justify-between bg-[rgba(10,10,10,0.39)]"
      >
        <div class="a-brand relative w-[210px] h-[63px]">
          <img
            class="absolute left-[-0.469px] top-[-13.5px] w-[210.469px] h-[112.5px]"
            src="@/assets/images/landing-a/brand.webp"
            alt="黄果免费看，每一帧都解你的色"
          />
          <img
            class="absolute left-0 top-[1.5px] w-[60px] h-[60px] rounded-[6px]"
            src="@/assets/images/landing-a/brand-icon.webp"
            alt=""
          />
        </div>
        <div class="a-services flex items-center gap-[24px]">
          <div
            v-if="swUrl"
            class="a-service relative w-[160px] h-[50px] cursor-pointer"
            @click="toContact(swUrl)"
          >
            <img
              class="absolute left-[-18px] top-[-12px] w-[196px] h-[86px]"
              src="@/assets/images/landing-a/pc-contact-sw.webp"
              alt="商务合作"
            />
          </div>
          <div
            v-if="qdUrl"
            class="a-service relative w-[160px] h-[50px] cursor-pointer"
            @click="toContact(qdUrl)"
          >
            <img
              class="absolute left-[-18px] top-[-12px] w-[196px] h-[86px]"
              src="@/assets/images/landing-a/pc-contact-qd.webp"
              alt="渠道合作"
            />
          </div>
          <div
            v-if="tgUrl"
            class="a-service relative w-[160px] h-[50px] cursor-pointer"
            @click="toContact(tgUrl)"
          >
            <img
              class="absolute left-[-18px] top-[-12px] w-[196px] h-[86px]"
              src="@/assets/images/landing-a/pc-contact-tg.webp"
              alt="官方群组"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDesktopRemBase } from "@/plugins/scale_no";

export default {
  props: ["qrImg", "configs", "version"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  mounted() {
    this.restoreDesktopRem = useDesktopRemBase(37.5);
  },
  beforeDestroy() {
    this.restoreDesktopRem();
  },
  methods: {
    toContact(url) {
      window.open(url);
    }
  }
};
</script>
